import React, { useEffect, useState } from 'react';

const MARQUEE_COPY =
  'MAPTOBE THE! PLACE TO BE  // URBAN GUIDE TO SARAJEVO // LARGEST DATABASE OF EVENTS IN BOSNIA // CODE:42 // BUREK NIJE SA SIROM // BEST FOOD // BEST COFFEE // BEST PEOPLE ';

/**
 * Decorative scrolling strip under PublicNav (site-wide public chrome).
 * Pauses CSS animation while the document is hidden to cut background GPU/CPU.
 */
const PublicMarqueeHeader = () => {
  const [paused, setPaused] = useState(
    () => typeof document !== 'undefined' && document.hidden
  );

  useEffect(() => {
    const onVisibility = () => setPaused(document.hidden);
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, []);

  return (
    <div className={`pub-marquee${paused ? ' pub-marquee--paused' : ''}`} aria-hidden="true">
      <div className="pub-marquee__track">
        <span>{MARQUEE_COPY}</span>
        <span>{MARQUEE_COPY}</span>
      </div>
    </div>
  );
};

export default PublicMarqueeHeader;
